import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { TermsOfAcceptance } from '@thro-types/leihbar';

import { AxiosRequestConfig } from 'axios';

import { getTermsOfAcceptance, updateOrCreateTermsOfAcceptance } from 'api/leihbar';

export const useTermsOfAcceptanceQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery<TermsOfAcceptance, Error>({
    queryKey: ['termsOfAcceptance', config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      return getTermsOfAcceptance(config);
    }
  });

  return query;
};

export const useTermsOfAcceptanceMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['termsOfAcceptance'];

  const update = useMutation<TermsOfAcceptance, Error>({
    mutationFn: async args => {
      return await updateOrCreateTermsOfAcceptance(config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });
  return { update } as const;
};
